<div id="sidebar">
  <div class="nav">
    <div class="logo mb-3">
      <app-logo></app-logo>
    </div>

    <ng-container *ngFor="let sideBarItem of menuItems$ | async">
      <button type="button" class="btn btn-navigate"
              [routerLink]="sideBarItem.link"
              [routerLinkActiveOptions]="{exact: sideBarItem.routerLinkExact}"
              routerLinkActive="active">
        <div class="d-flex align-items-center gap-2">
          <svg-icon *ngIf="sideBarItem.icon" [src]="'assets/image/icon/' + sideBarItem.icon + '.svg'"></svg-icon>
          <span
            class="label d-inline d-md-none d-lg-inline">{{ 'COMPONENT.SIDE_MENU.' + sideBarItem.title | translate }}</span>
        </div>
      </button>
    </ng-container>
  </div>

  <div class="d-flex flex-column gap-3">
    <small>{{ (user$ | async)?.email }}</small>
    <button type="button" class="btn btn-link btn-link-primary px-0"
            (click)="logout()">
      <div class="d-flex gap-3 align-items-center">
        <i-tabler name="logout" class="icon"></i-tabler>
        <span>{{ 'COMPONENT.SIDE_MENU.LOGOUT' | translate }}</span>
      </div>
    </button>
  </div>
</div>